import { KTIcon } from "../../../../../../_metronic/helpers";

const GateAddModalHeader = ({
  listing,
  device,
  setDevice,
  setOpenGateAddModal,
  changeStatus,
  setChangeStatus
}) => {
  return (
    <div className="modal-header">
      <h2 className="fw-bold listing_title">{device ? `${changeStatus ? device?.is_active ? 'Disable' : 'Enable' : 'Edit'} ${device.device_label}` : 'Add Gate'} for <span className="fw-bolder text-main">{listing.title}</span></h2>
      <div
        className="btn btn-icon btn-sm btn-active-icon-primary align-items-start align-self-start"
        data-kt-users-modal-action="close"
        onClick={() => {
          setDevice(null)
          setChangeStatus(false)
          setOpenGateAddModal(false)
        }}
        style={{ cursor: "pointer" }}
      >
        <KTIcon iconName="cross" className="fs-1" />
      </div>
    </div>
  );
};

export { GateAddModalHeader };
